import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  root: { marginBottom: 24 },
  inner: { height: 300, position: 'relative' }
}));

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function buildMonthlyData(chartArray) {
  const result = Array(12).fill(0);
  (chartArray || []).forEach((item) => {
    if (item.bulan >= 1 && item.bulan <= 12) {
      result[item.bulan - 1] = parseFloat(item.amount) || 0;
    }
  });
  return result;
}

function LokasiChart({ nama_lokasi, penjualan, pembelian, className }) {
  const classes = useStyles();

  const data = {
    labels: MONTHS,
    datasets: [
      {
        label: 'Penjualan (jt)',
        data: buildMonthlyData(penjualan),
        backgroundColor: 'rgba(25, 118, 210, 0.75)',
        borderColor: 'rgba(25, 118, 210, 1)',
        borderWidth: 1
      },
      {
        label: 'Pembelian (jt)',
        data: buildMonthlyData(pembelian),
        backgroundColor: 'rgba(229, 57, 53, 0.65)',
        borderColor: 'rgba(229, 57, 53, 1)',
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: true, position: 'top' },
    scales: {
      yAxes: [{ ticks: { beginAtZero: true, callback: (v) => `${v}jt` } }],
      xAxes: [{ gridLines: { display: false } }]
    },
    tooltips: {
      callbacks: {
        label: (item, d) =>
          `${d.datasets[item.datasetIndex].label}: ${parseFloat(item.yLabel).toFixed(2)}jt`
      }
    }
  };

  return (
    <Card className={classes.root}>
      <CardHeader title={`Penjualan vs Pembelian — ${nama_lokasi}`} />
      <Divider />
      <CardContent>
        <div className={classes.inner}>
          <Bar data={data} options={options} />
        </div>
      </CardContent>
    </Card>
  );
}

LokasiChart.propTypes = {
  nama_lokasi: PropTypes.string.isRequired,
  penjualan: PropTypes.array,
  pembelian: PropTypes.array,
  className: PropTypes.string
};

export default LokasiChart;
